module.exports = __webpack_public_path__ + "static/media/DSC_0061.0ac1e257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0061.jpg
// module id = 551
// module chunks = 0